import { getRouteApi, Link } from '@tanstack/react-router';
import { Settings } from '@tempo-io/sui-icons';
import { useTranslation } from 'react-i18next';
import { usePermission } from '@/common/hooks/usePermission';

const orgRoute = getRouteApi('/(app)/org/$org');

const DEFAULT_CLASS_NAME =
  'flex items-center gap-2 cursor-pointer text-text-neutral-primary text-sm no-underline';

export const SettingsGroupLabel = ({ className = DEFAULT_CLASS_NAME }: { className?: string }) => {
  const { org } = orgRoute.useParams();
  const { t } = useTranslation();
  const canEditIntegrations = usePermission('edit_integrations');

  if (!canEditIntegrations) {
    return null;
  }

  return (
    <Link
      to="/org/$org/settings/effort-estimation"
      params={{ org }}
      className={className}
      onClick={(e) => e.stopPropagation()}
    >
      <Settings className="size-4" />
      <span>{t(($) => $.common.estimation.defineRangesInSettings)}</span>
    </Link>
  );
};
